import { observer } from "mobx-react-lite";
import { Search, Archive, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SelectField } from "@/components/common/SelectField";
import { useTran } from "@/hooks";
import { customDisclosureStore } from "../../stores/custom-disclosure.store";

const DisclosureFilters = observer(() => {
  const { t } = useTran();
  const {
    searchQuery,
    categoryFilter,
    statusFilter,
    hasSelection,
    setSearchQuery,
    setCategoryFilter,
    setStatusFilter,
    handleBulkArchive,
    handleBulkDelete,
  } = customDisclosureStore;

  return (
    <div className="flex items-center gap-3">
      {/* Search */}
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder={t("Search by code or title...")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-9"
        />
      </div>

      {/* Category Filter */}
      <SelectField
        value={categoryFilter || "all"}
        onValueChange={setCategoryFilter}
        options={[
          { key: "all", label: t("All Categories") },
          { key: "Environment", label: t("Environment") },
          { key: "Social", label: t("Social") },
          { key: "Governance", label: t("Governance") },
        ]}
        placeholder={t("All Categories")}
        selectClassName="w-48"
      />

      {/* Status Filter */}
      <div className="flex gap-1 rounded-radius border border-border bg-card p-1">
        <button
          className={`px-3 py-1.5 text-sm font-medium rounded transition-colors ${
            statusFilter === "active"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"
          }`}
          onClick={() => setStatusFilter("active")}
        >
          {t("Active")}
        </button>
        <button
          className={`px-3 py-1.5 text-sm font-medium rounded transition-colors ${
            statusFilter === "all"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"
          }`}
          onClick={() => setStatusFilter("all")}
        >
          {t("All")}
        </button>
        <button
          className={`px-3 py-1.5 text-sm font-medium rounded transition-colors ${
            statusFilter === "archived"
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground"
          }`}
          onClick={() => setStatusFilter("archived")}
        >
          {t("Archived")}
        </button>
      </div>

      {/* Bulk Actions */}
      {hasSelection && (
        <div className="flex gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={handleBulkArchive}
            className="gap-2"
          >
            <Archive className="h-4 w-4" />
            {t("Archive Selected")}
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={handleBulkDelete}
            className="gap-2 text-destructive"
          >
            <Trash2 className="h-4 w-4" />
            {t("Delete Selected")}
          </Button>
        </div>
      )}
    </div>
  );
});

export default DisclosureFilters;
